import { ORGANIZATIONS_ENDPOINT } from "Constants";
import { baseApi as api } from "Services";
import {
  AddUsersToGroupRequest,
  CreateGroupRequest,
  CreateGroupResponse,
  CreateOrganizationRequest,
  CreateOrganizationResponse,
  DeleteGroupRequest,
  GetGroupRequest,
  GetGroupResponse,
  GetOrganizationListResponse,
  GetOrganizationRequest,
  GetOrganizationResponse,
  RemoveUsersFromGroupRequest,
  UpdateGroupRequest,
  UpdateOrganizationRequest,
} from "../types";

export const organizationsApi = api.injectEndpoints({
  endpoints: (build) => ({
    createOrganization: build.mutation<
      CreateOrganizationResponse,
      CreateOrganizationRequest
    >({
      query: (queryArg) => ({
        url: `${ORGANIZATIONS_ENDPOINT}/organization/create`,
        method: "POST",
        body: queryArg.body,
      }),
      invalidatesTags: ["Organizations"],
    }),
    getOrganizationList: build.query<GetOrganizationListResponse, void>({
      query: () => ({ url: `${ORGANIZATIONS_ENDPOINT}/organization/list` }),
      providesTags: ["Organizations"],
    }),
    getOrganization: build.query<
      GetOrganizationResponse,
      GetOrganizationRequest
    >({
      query: (queryArg) => ({
        url: `${ORGANIZATIONS_ENDPOINT}/organization/${queryArg.organizationId}`,
      }),
      providesTags: ["Organizations", "Groups", "Users"],
    }),
    updateOrganization: build.mutation<void, UpdateOrganizationRequest>({
      query: (queryArg) => ({
        url: `${ORGANIZATIONS_ENDPOINT}/organization/${queryArg.organizationId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
      invalidatesTags: ["Organizations", "Groups"],
    }),
    createGroup: build.mutation<CreateGroupResponse, CreateGroupRequest>({
      query: (queryArg) => ({
        url: `${ORGANIZATIONS_ENDPOINT}/group/create`,
        method: "POST",
        body: queryArg.body,
      }),
      invalidatesTags: ["Groups", "Organizations", "Usage"],
    }),
    getGroup: build.query<GetGroupResponse, GetGroupRequest>({
      query: (queryArg) => ({
        url: `${ORGANIZATIONS_ENDPOINT}/group/${queryArg.groupId}`,
      }),
      providesTags: ["Groups"],
    }),
    updateGroup: build.mutation<void, UpdateGroupRequest>({
      query: (queryArg) => ({
        url: `${ORGANIZATIONS_ENDPOINT}/group/${queryArg.groupId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
      invalidatesTags: ["Groups", "Organizations", "Usage"],
    }),
    deleteGroup: build.mutation<void, DeleteGroupRequest>({
      query: (queryArg) => ({
        url: `${ORGANIZATIONS_ENDPOINT}/group/${queryArg.groupId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Groups", "Organizations", "Usage"],
    }),
    addUsersToGroup: build.mutation<void, AddUsersToGroupRequest>({
      query: (queryArg) => ({
        url: `${ORGANIZATIONS_ENDPOINT}/group/${queryArg.groupId}/add-users`,
        method: "PATCH",
        body: queryArg.body,
      }),
      invalidatesTags: ["Groups", "Users"],
    }),
    removeUsersFromGroup: build.mutation<void, RemoveUsersFromGroupRequest>({
      query: (queryArg) => ({
        url: `${ORGANIZATIONS_ENDPOINT}/group/${queryArg.groupId}/remove-users`,
        method: "PATCH",
        body: queryArg.body,
      }),
      invalidatesTags: ["Groups", "Users"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetOrganizationQuery,
  useCreateGroupMutation,
  useGetGroupQuery,
  useUpdateGroupMutation,
  useDeleteGroupMutation,
  useAddUsersToGroupMutation,
  useRemoveUsersFromGroupMutation,
} = organizationsApi;
